import React, { useEffect, useState } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { get } from 'lodash';
import { clearFeesValidationErrors, editSettings, fetchSettings } from './SettingsActions';
import SettingsForm from './form/SettingsForm';
import validationSchema from './form/SettingsForm.schema';
import { pencesToPounds } from '../common/helpers/pencesToPounds';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import ComponentCard from '../common/components/cards/ComponentCard';

function SettingsPage() {
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState({
    monthlySubscriptionInPence: '0',
    launchInPence: '0',
    saleForLessThan1000InPence: '0',
    saleBetween1001And5000InPence: '0',
    saleBetween5001And10000InPence: '0',
    saleBetween10001And15000InPence: '0',
    saleForMoreThan15000InPence: '0',
    purchaseForLessThan1000InPence: '0',
    purchaseBetween1001And5000InPence: '0',
    purchaseBetween5001And10000InPence: '0',
    purchaseBetween10001And15000InPence: '0',
    purchaseForMoreThan15000InPence: '0',
    version: 0,
  });

  const safePoundsString = (value) => {
    const pounds = pencesToPounds(value);
    return pounds != null ? String(pounds) : '0';
  };

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  const data = useSelector((state) => state.settings.get('mainSettings'));

  useEffect(() => {
    if (data?.size !== 0) {
      setInitialValues({
        monthlySubscriptionInPence: safePoundsString(get(data, 'monthlySubscriptionInPence')),
        launchInPence: safePoundsString(get(data, 'launchInPence')),
        saleForLessThan1000InPence: safePoundsString(get(data, 'saleForLessThan1000InPence')),
        saleBetween1001And5000InPence: safePoundsString(
          get(data, 'saleBetween1001And5000InPence'),
        ),
        saleBetween5001And10000InPence: safePoundsString(
          get(data, 'saleBetween5001And10000InPence'),
        ),
        saleBetween10001And15000InPence: safePoundsString(
          get(data, 'saleBetween10001And15000InPence'),
        ),
        saleForMoreThan15000InPence: safePoundsString(
          get(data, 'saleForMoreThan15000InPence'),
        ),
        purchaseForLessThan1000InPence: safePoundsString(
          get(data, 'purchaseForLessThan1000InPence'),
        ),
        purchaseBetween1001And5000InPence: safePoundsString(
          get(data, 'purchaseBetween1001And5000InPence'),
        ),
        purchaseBetween5001And10000InPence: safePoundsString(
          get(data, 'purchaseBetween5001And10000InPence'),
        ),
        purchaseBetween10001And15000InPence: safePoundsString(
          get(data, 'purchaseBetween10001And15000InPence'),
        ),
        purchaseForMoreThan15000InPence: safePoundsString(
          get(data, 'purchaseForMoreThan15000InPence'),
        ),
        version: get(data, 'version'),
      });
    }
  }, [data]);

  const handleSubmit = (values, { setSubmitting }) => {
    dispatch(editSettings(values))
      .then(() => setSubmitting(false))
      .catch(() => {});
  };

  useEffect(() => () => dispatch(clearFeesValidationErrors()), [dispatch]);

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'span', text: 'Fee Settings' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Fee Settings" />
      <Row>
        <Col md="12">
          <ComponentCard title="Fee Settings">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              validateOnBlur
              enableReinitialize
            >
              {() => <SettingsForm />}
            </Formik>
          </ComponentCard>
        </Col>
      </Row>
    </Container>
  );
}

export default SettingsPage;
